/**
 * As imagens de um evento de colar — o caminho do Ctrl+V no composer.
 *
 * Puro e fora do componente, como o resto de `utils/`: o teste passa um objeto
 * literal com `clipboardData.items` e prova a regra sem montar Vue nem simular
 * um `ClipboardEvent` de verdade (jsdom não constrói um com `items`).
 *
 * ★ Mesma leitura que `task-comment-attachment-picker.handlePaste` faz no módulo
 * de tarefas, e que `atendimento/chat-input` faz no WhatsApp. Aqui ela é
 * FUNÇÃO, e não método, porque três portas de entrada (o `+`, o Ctrl+K e este)
 * desembocam no mesmo `adicionar` — a extração precisa ser chamável de fora.
 *
 * ⚠️ Devolve `[]` quando não há imagem, e quem chama SÓ pode dar
 * `preventDefault()` se a lista vier cheia. O evento carrega texto E imagem em
 * alguns browsers; prevenir sempre faz o `data:image/...` ser colado como texto
 * dentro do campo — o defeito está registrado em `atendimento/chat-input.vue`.
 *
 * @param {ClipboardEvent} evento Evento de `paste`.
 * @returns {Array} `File[]` das imagens do clipboard, na ordem em que vieram.
 */
export function imagensDoClipboard(evento) {
  const dados = evento && evento.clipboardData
  const itens = dados && dados.items
  if (!itens || !itens.length) return []

  const imagens = []
  // `for` indexado e não `for...of`: `DataTransferItemList` é array-like e não
  // é iterável em todo browser que o projeto suporta.
  for (let i = 0; i < itens.length; i += 1) {
    const item = itens[i]
    const ehArquivo = item && item.kind === 'file'
    const ehImagem = ehArquivo && String(item.type).indexOf('image/') === 0
    if (!ehImagem) continue
    // `getAsFile` devolve `null` quando o item já foi consumido — acontece se
    // alguém ler o mesmo evento duas vezes.
    const arquivo = item.getAsFile()
    if (arquivo) imagens.push(arquivo)
  }
  return imagens
}
